<template>
  <ci-pipelines
    :is-loading="isLoading"
    :repositories="config.repositories"
    :variable-hints="config.variableHints"
    :history="history"
    :history-total="historyTotal"
    :pipeline-jobs="pipelineJobs"
    :download="download"
    @run-pipeline="onRunPipeline"
    @show-history="onShowHistory"
    @get-pipeline-info="onGetPipelineInfo"
    @download-artifacts="onDownloadArtifacts"
  />
</template>

<script>
import { API } from '@/utils/api'
import CiPipelines from '../components/CiPipelines.vue';

export default {
  components: {
    CiPipelines,
  },
  data() {
    return {
      isLoading: false,
      config: {
        repositories: [],
        variableHints: {},
      },
      history: [],
      historyTotal: 0,
      pipelineJobs: [],
      download: {
        progress: 0,
        total: 0,
        type: 'artifacts', // 'artifact' | 'trace'
        isInProgress: false,
      }
    }
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    loadConfig() {
      this.isLoading = true
      return API.call('/$v/tools/ci_config.json').then(r => {
        this.config = r.data
      }).finally(() => this.isLoading = false)
    },
    onRunPipeline(args) {
      this.isLoading = true
      return API.call('/$v/tools/ci_run_pipeline.json', args).then(r => {
        this.$showSuccess('Pipeline launched successfully')
      }).finally(() => this.isLoading = false)
    },
    onShowHistory(args) {
      this.isLoading = true
      return API.call('/$v/tools/ci_history.json', args).then(r => {
        this.history = r.data
        this.historyTotal = r.total
      }).finally(() => this.isLoading = false)
    },
    onGetPipelineInfo(args) {
      this.isLoading = true
      this.pipelineJobs = []
      return API.call('/$v/tools/ci_pipeline_info.json', args)
        .then(r => this.pipelineJobs = r.data)
        .finally(() => this.isLoading = false)
    },
    onDownloadArtifacts(args) {
      this.download.isInProgress = true
      this.download.type = args.type
      this.download.progress = 0
      this.download.total = 0

      return API.call('/$v/tools/ci_download_artifacts.json', args, null, null, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          this.download.progress = progressEvent.loaded
          this.download.total = progressEvent.total
        },
      })
        .then(r => {
          const blobURL = window.URL.createObjectURL(r);
          const tempLink = document.createElement('a');
          tempLink.href = blobURL;
          tempLink.setAttribute('download', `${args.type}-${args.pipeline_id}-${args.job_id}.${args.type === 'artifacts' ? 'zip' : 'txt'}`);

          tempLink.click();
          window.URL.revokeObjectURL(blobURL);
        })
        .finally(() => {
          this.download.isInProgress = false
        })
    },
  }
}
</script>
